import { applyMiddleware, compose, createStore } from "redux";
import { thunk } from "redux-thunk";
import { rootReducers } from "./reducers/rootReducers";

//import persistReducer from "redux-persist/es/persistReducer";
// const persistConfig = {
//   key: "root",
//   storage: localforage,
// };
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const persistedReducer = persistReducer(persistConfig, rootReducers);
const store = createStore(rootReducers, compose(applyMiddleware(thunk)));
//const persistor = persistStore(store);

export { store };
